<div class="dialog-shell">
    <div class="dialog-topbar">
        <button mat-icon-button mat-dialog-close class="button-close--outlined dialog-close" color="primary" aria-label="Chiudi">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-head">
        <h1 mat-dialog-title class="dialog-title">Registrazione</h1>
        <p class="dialog-subtitle">Crea il tuo account per richiedere un interprete e gestire i tuoi appuntamenti.</p>
    </div>

    <div mat-dialog-content class="dialog-body">
        <form [formGroup]="formGroup" (ngSubmit)="onYesClick()" class="dialog-form">
            <div class="dialog-loading" *ngIf="loading">
                <mat-spinner></mat-spinner>
            </div>

            <div class="form-sections" *ngIf="!loading">
                <section class="form-section">
                    <h2 class="section-title">Credenziali di accesso</h2>

                    <div class="form-grid">
                        <mat-form-field class="fo-field is-full">
                            <mat-label>Username</mat-label>
                            <input matInput type="text" formControlName="username" autocomplete="username" required />
                            <mat-icon matSuffix>face</mat-icon>
                        </mat-form-field>

                        <mat-form-field class="fo-field">
                            <mat-label>Password</mat-label>
                            <input matInput type="password" formControlName="password" autocomplete="new-password" required />
                            <mat-icon matSuffix>vpn_key</mat-icon>
                            <mat-error class="error-message" *ngIf="formGroup?.get('password').hasError('policyNotMatch')"
                                >Lunga 10 con una minuscola, una maiuscola, un numero e un simbolo</mat-error
                            >
                            <mat-error class="error-message" *ngIf="formGroup?.get('password').hasError('required')"
                                >La nuova password è obbligatoria</mat-error
                            >
                            <mat-error class="error-message" *ngIf="formGroup?.get('password').hasError('whiteSpace')"
                                >Gli spazi non sono ammessi</mat-error
                            >
                            <mat-error class="error-message" *ngIf="formGroup?.get('password').hasError('passwordMatch')"
                                >Le password devono corrispondere</mat-error
                            >
                        </mat-form-field>

                        <mat-form-field class="fo-field">
                            <mat-label>Conferma Nuova Password</mat-label>
                            <input matInput type="password" formControlName="confirm_password" autocomplete="new-password" required />
                            <mat-icon matSuffix>vpn_key</mat-icon>
                            <mat-error class="error-message" *ngIf="formGroup?.get('confirm_password').hasError('required')"
                                >La conferma della password è obbligatoria</mat-error
                            >
                            <mat-error class="error-message" *ngIf="formGroup?.get('confirm_password').hasError('passwordMatch')"
                                >Le password devono corrispondere</mat-error
                            >
                        </mat-form-field>
                    </div>
                </section>

                <section class="form-section">
                    <h2 class="section-title">Dati personali</h2>

                    <div class="form-grid" formGroupName="userdata">
                        <mat-form-field class="fo-field">
                            <mat-label>Nome</mat-label>
                            <input matInput type="text" formControlName="name" autocomplete="given-name" required />
                            <mat-icon matSuffix>face</mat-icon>
                            <mat-error class="error-message" *ngIf="formGroup?.get('userdata.name').hasError('required')"
                                >Campo obbligatorio</mat-error
                            >
                            <mat-error class="error-message" *ngIf="formGroup?.get('userdata.name').hasError('alphabeticOnly')"
                                >Numeri non permessi</mat-error
                            >
                        </mat-form-field>

                        <mat-form-field class="fo-field">
                            <mat-label>Cognome</mat-label>
                            <input matInput type="text" formControlName="surname" autocomplete="family-name" required />
                            <mat-icon matSuffix>face</mat-icon>
                            <mat-error class="error-message" *ngIf="formGroup?.get('userdata.surname').hasError('required')"
                                >Campo obbligatorio</mat-error
                            >
                            <mat-error class="error-message" *ngIf="formGroup?.get('userdata.surname').hasError('alphabeticOnly')"
                                >Numeri non permessi</mat-error
                            >
                        </mat-form-field>
                    </div>
                </section>

                <section class="form-section">
                    <h2 class="section-title">Contatti</h2>

                    <div class="form-grid" formGroupName="userdata">
                        <mat-form-field class="fo-field">
                            <mat-label>Indirizzo e-mail</mat-label>
                            <input matInput type="text" formControlName="email" autocomplete="email" required />
                            <mat-icon matSuffix>mail_outline</mat-icon>
                            <mat-error class="error-message" *ngIf="formGroup?.get('userdata.email').hasError('required')"
                                >Campo obbligatorio</mat-error
                            >
                            <mat-error class="error-message" *ngIf="formGroup?.get('userdata.email').hasError('email_custom')"
                                >Formato Mail errato</mat-error
                            >
                        </mat-form-field>

                        <mat-form-field class="fo-field">
                            <mat-label>Telefono</mat-label>
                            <input matInput type="text" formControlName="phone" autocomplete="tel" required />
                            <mat-icon matSuffix>local_phone</mat-icon>
                            <mat-error class="error-message" *ngIf="formGroup?.get('userdata.phone').hasError('required')"
                                >Campo obbligatorio</mat-error
                            >
                            <mat-error class="error-message" *ngIf="formGroup?.get('userdata.phone').hasError('numericOnly')"
                                >Lettere non permesse</mat-error
                            >
                        </mat-form-field>
                    </div>
                </section>

                <section class="form-section">
                    <h2 class="section-title">Informazioni aggiuntive</h2>

                    <div class="form-grid" formGroupName="userdata">
                        <mat-form-field class="fo-field">
                            <mat-label>Sesso</mat-label>
                            <mat-select formControlName="gender" required>
                                <mat-option *ngFor="let sex of gender" [value]="sex.id">
                                    {{ sex.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error class="error-message" *ngIf="formGroup?.get('userdata.gender').hasError('required')"
                                >Campo obbligatorio</mat-error
                            >
                        </mat-form-field>

                        <mat-form-field class="fo-field">
                            <mat-label>Regione</mat-label>
                            <mat-select formControlName="id_region" required>
                                <mat-option *ngFor="let region of regions" [value]="region.id">
                                    {{ region.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error class="error-message" *ngIf="formGroup?.get('userdata.id_region').hasError('required')"
                                >Campo obbligatorio</mat-error
                            >
                        </mat-form-field>
                    </div>
                </section>

                <section class="form-section">
                    <h2 class="section-title">Consensi privacy</h2>

                    <div class="consent-list" formGroupName="userdata">
                        <div class="fo-card consent-row">
                            <p class="consent-text">
                                Acconsento al trattamento dei miei dati personali di contatto per ricevere comunicazione dal
                                Titolare circa nuovi servizi e/o proposte rivolte dal Titolare agli iscritti alla Piattaforma.
                            </p>
                            <mat-slide-toggle
                                formControlName="privacy_communications"
                                aria-label="Consenso alle comunicazioni del Titolare"
                            ></mat-slide-toggle>
                        </div>

                        <div class="fo-card consent-row">
                            <p class="consent-text">
                                Acconsento alla comunicazione dei miei dati personali di contatto a società terze per ricevere da
                                queste ultime offerte e/o comunicazioni appositamente dedicate a soggetti non udenti.
                            </p>
                            <mat-slide-toggle
                                formControlName="privacy_third_part"
                                aria-label="Consenso alla comunicazione dei dati a società terze"
                            ></mat-slide-toggle>
                        </div>

                        <div class="fo-card consent-row is-required">
                            <p class="consent-text">
                                Autorizzo il trattamento dei miei dati personali necessari per potere accedere alla Piattaforma e
                                per consentire la navigazione al suo interno in base e per le finalità riportate nella correlata
                                Informativa. *
                            </p>
                            <mat-slide-toggle
                                formControlName="privacyaccept"
                                required
                                aria-label="Autorizzazione al trattamento dei dati personali, obbligatoria"
                            ></mat-slide-toggle>
                        </div>

                        <p class="consent-error" *ngIf="formGroup?.get('userdata.privacyaccept')?.hasError('required')">
                            Campo obbligatorio
                        </p>
                    </div>
                </section>
            </div>

            <div class="dialog-footer">
                <button type="submit" class="fo-btn fo-btn--primary fo-btn--block" [disabled]="!formGroup.valid">Procedi</button>
            </div>
        </form>
    </div>
</div>
